import {ModuleNode, extractModuleIdentifiers} from '@backstage-components/base';
import type {FC} from 'react';
import {ButtonComponent, IButtonProps} from './ButtonComponent';
import {SchemaType} from './ButtonDefinition';

export type ButtonProps = SchemaType & IButtonProps;

export const ButtonPreviewComponent: FC<ModuleNode<'Button', ButtonProps>> = (
  definition
) => {
  const {props} = definition.module;
  return (
    <ButtonComponent
      config={{scope: 'admin'}}
      component={definition.module.component}
      {...extractModuleIdentifiers(definition.module)}
      props={props}
    />
  );
};
